import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import NoteEditor from 'components/Editors/NoteEditor'

class RichTextEditor extends PureComponent {
  static propTypes = {
    noteId: PropTypes.string.isRequired,
    userCanEdit: PropTypes.bool.isRequired,
    titlePlaceholder: PropTypes.string,
    onEditorRef: PropTypes.func,
    focusNoteTitleInput: PropTypes.func,
  }

  render() {
    return (
      <React.Fragment>
        <NoteEditor
          key={this.props.noteId} // Needed to wiped plugins internal state
          noteId={this.props.noteId}
          userCanEdit={this.props.userCanEdit}
          onEditorRef={this.props.onEditorRef}
          focusPrev={this.props.focusNoteTitleInput}
        />
      </React.Fragment>
    )
  }
}

export default RichTextEditor
